<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">Of all the benefits</p>
<p class="fm_hang">which virtue confers on us,</p>
<p class="fm_hang">the contempt of death</p>
<p class="fm_hang">is one of the greatest.</p>
<p class="right"><span>—Michel de Montaigne</span></p>
<p class="fm_hang">Death is watching me.</p>
<p class="fm_hang">I am watching her back.</p>
<p class="fm_hang">It is a game</p>
<p class="fm_hang">at which two can play.</p>
<p class="right"><span>—Mack Bolan, the Executioner</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?fecfa94a